<template>
  <div class="questionDetails" style="min-height:35vw">
    <div class="container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/questiontList' }"
          >问题列表</el-breadcrumb-item
        >
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 详情组件 -->
      <div class="details-boxs">
        <div class="details-title">{{ respData.title }}</div>
        <div class="details-info">
          <span>发布人：{{ respData.publishByName }}</span>
          <span>{{ respData.publishDate | timerData }}</span>
          <span>阅读量：{{ respData.readingQuantity }}</span>
        </div>
        <div class="details-content">
          <p>{{ respData.detail }}</p>
        </div>
        <div class="imgDateil">
          <template v-for="(item, index) in respData.picList">
            <img :key="index" :src="$img + item.pictureUrl" alt />
          </template>
        </div>
      </div>
      <!-- 问答发布--- -->
      <div class="question-box">
        <div class="ques-box clearf">
          <img class="ques-box-img" src="/static/img/questImg.jpg" alt />
          <div class="ques-box-input">
            <input
              type="text"
              id="quesInput"
              placeholder="写下您的评论。。"
              v-model="quesContent"
            />
            <el-button
              type="success"
              @click="bindSubmit(tid)"
              style="height:45px;width:100px;border:none;position: absolute;top:0;right: 0;background:#149508;border-radius: 0;"
              >发布</el-button
            >
          </div>
        </div>

        <!-- 问答回复 -->
        <div class="reply">
          <!-- <p>66666</p> -->
          <!-- <ul v-for="(item,index) in content" :key="index">
             <span>{{item.content}}</span>
          </ul>-->
          <ul v-for="(item, index) in contentList" :key="index">
            <li class="reply-li clearf">
              <img
                v-if="!item.expertCoverUrl"
                class="ques-box-img left"
                src="/static/img/questImg.jpg"
              />
              <img
                v-if="item.expertCoverUrl"
                class="ques-box-img left"
                :src="$img + item.expertCoverUrl"
              />
              <div class="ques-p left">
                <p>
                  <span class="ques-name">{{ item.publishByName }}</span>
                  <span class="color-nine">{{ item.createDate | timer }}</span>
                </p>
                <!-- v-if="item.tid == useId && show" -->
                <p class="margin-pss">
                  <span>{{ item.content }}</span>
                </p>
                <!-- <p v-if="item.tid != useId && show" class="margin-p">
                  <span>{{item.content}}</span>
                </p>
                <p v-if="item.tid == useId && !show" class="margin-p">
                  <span>{{item.content}}</span>
                </p>
                <p v-if="item.tid != useId && !show" class="margin-p">
                  <span>{{item.content}}</span>
                </p>-->

                <div class="clearf">
                  <p class="left curSot">
                    <span class="ques-name" @click="Reply(item, index)">
                      <span v-if="item.count == 0" onselectstart="return false">
                        <span>{{ item.count }}条回复</span>
                      </span>
                      <span v-if="item.count > 0" onselectstart="return false">
                        <span>{{
                          item.tid == useId && show
                            ? "收起回复"
                            : item.count + "条回复"
                        }}</span>
                        <!-- <img
                          class="img-top"
                          :src="item.tid == useId && show?'../assets/top.png':'../assets/bottom.png'"
                          alt
                        />-->
                      </span>
                    </span>
                  </p>
                  <p class="right" @click="Fabulous(item, index, 1)">
                    <span class="fabu-num">{{ item.times }}</span>
                    <img
                      class="img-fabulous curSot"
                      v-if="item.agreeState == 0 && item.tid != fuseId"
                      src="../assets/Fabulous99.png"
                      alt
                    />
                    <img
                      class="img-fabulous curSot"
                      v-if="item.agreeState == 1 && item.tid != fuseId"
                      src="../assets/fabulous.png"
                      alt
                    />
                    <img
                      v-if="item.tid == fuseId && bulous"
                      class="img-fabulous curSot"
                      src="../assets/fabulous.png"
                      alt
                    />
                    <img
                      v-if="item.tid == fuseId && !bulous"
                      class="img-fabulous curSot"
                      src="../assets/Fabulous99.png"
                      alt
                    />
                  </p>
                  <p class="right" style="margin:6px 15px 0 0;color:#bbb">|</p>
                  <p class="right" style="margin-top:6px">
                    <span
                      class="ques-name curSot"
                      @click="replyShowclick(item)"
                      onselectstart="return false"
                      >回复</span
                    >
                  </p>
                </div>
                <el-input
                  v-if="item.tid == useId && replyShow"
                  :placeholder="'回复: ' + item.publishByName"
                  v-model="Oneinput"
                  clearable
                  @keyup.enter.native="OneshowInput(item, index)"
                  style="margin-bottom:10px;"
                ></el-input>

                <ul v-for="(secitem, index) in setContent" :key="index">
                  <li
                    class="reply-li clearf"
                    v-if="show && item.count != 0 && item.tid == useId"
                  >
                    <img
                      v-if="!secitem.expertCoverUrl"
                      class="ques-box-img left"
                      src="/static/img/questImg.jpg"
                    />
                    <img
                      v-if="secitem.expertCoverUrl"
                      class="ques-box-img left"
                      :src="$img + secitem.expertCoverUrl"
                    />
                    <div class="ques-p left">
                      <p>
                        <span class="ques-name">{{
                          secitem.publishByName
                        }}</span>
                        <span class="color-nine">{{
                          secitem.createDate | timer
                        }}</span>
                      </p>
                      <p class="margin-pss">
                        <span v-if="!secitem.commentPerson">{{
                          secitem.content
                        }}</span>
                        <span v-if="secitem.commentPerson">
                          <span>回复:</span>
                          <span style="color:#149508"
                            >@{{ secitem.commentPerson }}</span
                          >
                          <span>{{ secitem.content }}</span>
                        </span>
                      </p>

                      <div class="clearf">
                        <p class="right" @click="secBulous(secitem, index, 2)">
                          <span class="fabu-num">{{ secitem.times }}</span>
                          <img
                            class="img-fabulous curSot"
                            v-if="
                              secitem.agreeState == 0 &&
                                secitem.tid != secitemUseid
                            "
                            src="../assets/Fabulous99.png"
                            alt
                          />
                          <img
                            class="img-fabulous curSot"
                            v-if="
                              secitem.agreeState == 1 &&
                                secitem.tid != secitemUseid
                            "
                            src="../assets/fabulous.png"
                            alt
                          />
                          <img
                            v-if="secitem.tid == secitemUseid && setbulous"
                            class="img-fabulous curSot"
                            src="../assets/fabulous.png"
                            alt
                          />
                          <img
                            v-if="secitem.tid == secitemUseid && !setbulous"
                            class="img-fabulous curSot"
                            src="../assets/Fabulous99.png"
                            alt
                          />
                        </p>
                        <p class="right" style="margin:6px 15px 0 0;color:#bbb">
                          |
                        </p>
                        <p class="right" style="margin-top:6px">
                          <span
                            class="ques-name curSot"
                            @click="itemReply(secitem)"
                            onselectstart="return false"
                            >回复</span
                          >
                        </p>
                      </div>
                      <el-input
                        v-if="secitem.tid == secitemId && replyTwoShow"
                        :placeholder="'回复: ' + secitem.publishByName"
                        v-model="twoInput"
                        clearable
                        style="margin-top:10px;"
                        @keyup.enter.native="
                          TwoshowInput(secitem, item.tid, index)
                        "
                      ></el-input>
                    </div>
                  </li>
                </ul>
                <div
                  v-if="
                    show && item.count != 0 && item.tid == useId && showsList
                  "
                  class="view-more"
                  onselectstart="return false"
                  @click="veiwtwoMore(item.tid, contData)"
                >
                  查看更多回复
                </div>
              </div>
            </li>
          </ul>
          <div
            v-if="shows && contentList.length != 0"
            class="view-more"
            onselectstart="return false"
            @click="veiwMore(tid, Datas)"
          >
            查看更多评论
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Details from "../components/Details";
import moment from "moment";
import cookie from "js-cookie";
export default {
  props: ["message"],
  data() {
    return {
      Details: "",
      twoInput: "",
      quesContent: "",
      onUserId: "0",
      Oneinput: "",
      bulous: "",
      setbulous: false,
      shows: false,
      Datas: "",
      setContent: [],
      tid: "",
      times: "",

      pageNum: 1,
      pageSize: "10",
      pageSizecont: "5",
      useId: "",
      userId: "",
      fuseId: "",
      secitemId: "",
      secitemUseid: "",
      setuserId: "",
      respData: "",
      username: "",
      telephone: "",
      show: false,
      replyShow: false,
      replyTwoShow: false,
      showsList: false,
      questionId: "",
      content: [],
      contentList: [],
      contData: "",
      counTs: 0,
      stat: 0,
      statTwo: 0,
      list: [
        {
          name: "南风",
          time: "20小时",
          id: "1",
          content:
            "公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、实地勘察、价值评估、融资担",
          lists: [
            {
              names: "北风",
              id: "3",
              time: "1分钟前",
              contents:
                "公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，"
            },
            {
              names: "北风",
              id: "3",
              time: "1分钟前",
              contents:
                "公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，"
            }
          ]
        },
        {
          name: "土流网",
          time: "3分钟前",
          id: "4",
          content:
            "公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、"
        },
        {
          name: "南苑生烟",
          time: "3分钟前",
          id: "40",
          content:
            "公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、"
        },
        {
          name: "躲猫猫",
          time: "3分钟前",
          id: "10",
          content:
            "公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、公司将土地服务从线上延伸至线下，从土地的初步选取到信息核实、",
          lists: [
            {
              names: "北风",
              id: "3",
              time: "1分钟前",
              contents:
                "公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，公司将土地服务从线上延伸至线下，"
            }
          ]
        }
      ]
    };
  },
  components: {
    Details
  },
  filters: {
    timer(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    timerData(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  },
  mounted(e) {
    if (cookie.get("user")) {
      let user = cookie.get("user");
      this.userId = JSON.parse(user).tid;
      this.username = JSON.parse(user).username;
      this.telephone = JSON.parse(user).telephone;
      console.log(this.userId);
    } else if (sessionStorage.getItem("user")) {
      let user = sessionStorage.getItem("user");
      this.userId = JSON.parse(user).tid;
      this.username = JSON.parse(user).username;
      this.telephone = JSON.parse(user).telephone;
    }
    this.list = this.list;
    let tid = this.$route.query.tid;
    this.tid = tid;
    this.questionDetails(tid);
    this.commitList(tid);
    console.log(this.list, "list", tid);
  },
  methods: {
    // 问答详情接口
    questionDetails(tid) {
      let pageSize = this.pageSize;
      let pageNum = this.pageNum;
      let data = {
        tid: tid,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.$api.questionApi
        .questionDetail(data)
        .then(res => {
          console.log("问答详情=>", res);
          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    // 看评论
    commitList(tid) {
      let userId = this.userId;
      let username = this.username;
      let telephone = this.telephone;
      let pageSize = this.pageSize;
      let pageNum = this.pageNum;
      let data = {
        questionId: tid,
        userId: userId,
        username: username,
        telephone: telephone,
        pageSize: pageSize,
        pageNum: pageNum
      };
      this.$api.questionApi
        .commitList(data)
        .then(res => {
          console.log("查看评论=>", res);
          this.Datas = res.data.respData;
          this.statTwo == 0;
          if (res.data.respData.content.length > 0) {
            console.log(this.stat);
            if (this.shows == true && this.stat == 1) {
              this.contentList =
                this.contentList.concat(res.data.respData.content) || "";

              console.log("坚持");
            } else {
              console.log("加油");
              this.contentList = res.data.respData.content;
            }

            console.log(this.contentList);
            if (
              res.data.respData.totalPages > 1 &&
              this.pageNum < res.data.respData.totalPages
            ) {
              this.shows = true;
            }
          }
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    // 看回复
    commitReply(tid, index, fid) {
      let userId = this.userId;
      let username = this.username;
      let telephone = this.telephone;
      let pageSize = this.pageSizecont;
      let pageNum = this.pageNum;
      let data = {
        userId: userId,
        username: username,
        telephone: telephone,
        tid: tid || fid,
        pageSize: pageSize,
        pageNum: pageNum
      };
      this.$api.questionApi
        .commitReply(data)
        .then(res => {
          console.log("查看回复=>", res);
          this.show = true;
          this.contData = res.data.respData;
          if (index || index === 0) {
            this.contentList[index].count = res.data.respData.totalElements;
          }
          if (res.data.respData.content.length > 0) {
            console.log(this.statTwo);
            if ((this.showsList = true && this.statTwo == 1)) {
              this.setContent =
                this.setContent.concat(res.data.respData.content) || "";
              console.log("坚持");
            } else {
              console.log("加油");
              this.setContent = res.data.respData.content;
            }
            if (
              res.data.respData.totalPages > 1 &&
              this.pageNum < res.data.respData.totalPages
            ) {
              this.showsList = true;
            }
          }
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    // 评论问题
    addWebAnswer(tid) {
      let params = new FormData();
      params.append("userId", this.userId);
      params.append("username", this.username);
      params.append("telephone", this.telephone);
      params.append("questionId", tid);
      params.append("content", this.quesContent);
      this.$api.questionApi
        .addWebAnswer(params)
        .then(res => {
          console.log("评论问题=>", res);
          if (res.data.respCode == 0) {
            this.$message({
              message: res.data.respMsg,
              type: "warning"
            });
          } else {
            this.$message({
              message: "成功",
              type: "success"
            });
            this.quesContent = "";
            let tid = this.tid;
            this.commitList(tid);
          }
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    // 点赞
    updateAgree(tids, index, nums) {
      let params = new FormData();
      params.append("userId", this.userId);
      params.append("username", this.username);
      params.append("telephone", this.telephone);
      params.append("tid", tids);
      this.$api.questionApi
        .updateAgree(params)
        .then(res => {
          console.log("点赞=>", res);
          if (res.data.respCode) {
            this.$message({
              message: "点赞成功",
              type: "success"
            });
          }
          if (res.data.respCode == 0) {
            this.$message({
              message: "您已经点过赞了",
              type: "warning"
            });
            return;
          }

          console.log(index, "-----------------");
          if (index || index === 0) {
            if (nums == 1) {
              // 一级点赞
              this.contentList[index].times++;
              if (this.contentList[index].agreeState != 1) {
                this.contentList[index].agreeState++;
              }
            }
            if (nums == 2) {
              // 二级点赞
              this.setContent[index].times++;
              if (this.setContent[index].agreeState != 1) {
                this.setContent[index].agreeState++;
              }
            }
          }
          let tid = this.tid;
          // this.commitList(tid);
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },

    //回复评论
    addWebComment(item, input, fid, index, idss) {
      console.log("-----------", item, input, fid, index, idss);
      let params = new FormData();
      params.append("userId", this.userId);
      params.append("username", this.username);
      params.append("telephone", this.telephone);
      params.append("questionId", item.questionId);
      params.append("fid", fid);
      params.append("commentId", item.tid);
      params.append("content", input);
      let tid = fid;

      this.$api.questionApi
        .addWebComment(params)
        .then(res => {
          console.log("回复评论=>", res);
          this.$message({
            message: "成功",
            type: "success"
          });
          this.statTwo = 0;
          this.stat = 0;
          // if (index || index === 0) {
          //   this.contentList[index].count++;
          // }

          if (idss == 1) {
            this.commitReply(tid);
          }
          this.replyShow = false;
          this.replyTwoShow = false;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },

    // 发布评论
    bindSubmit(tid) {
      if (this.userId == "") {
        this.quesContent = "";
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });

        return;
      }
      let statu = document.getElementById("quesInput").value;
      if (statu.length > 200) {
        this.$message({
          message: "超过字数限制啦",
          type: "warning"
        });
        return;
      }
      this.addWebAnswer(tid);
      this.stat = 0;
      this.pageNum = 1;
    },
    // 点击赞
    Fabulous(item, index, nums) {
      console.log(item);
      if (this.userId == "") {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }
      this.bulous = true;
      this.fuseId = item.tid;
      let tids = item.tid;
      let tid = this.tid;
      // if (index || index === 0) {
      //   if (nums == 1) {
      //     if (this.contentList[index].agreeState != 1) {
      //       this.contentList[index].agreeState++;
      //       console.log(this.contentList[index].agreeState);
      //     }
      //   }
      //   if (nums == 2) {
      //     // 二级点赞
      //     this.setContent[index].agreeState + 1;
      //     // this.contentList[index].agreeState = 1;
      //     // this.setContent[index].agreeState = 1;
      //   }
      // }
      this.updateAgree(tids, index, nums);
    },
    // 二级点赞
    secBulous(secitem, index, nums) {
      if (this.userId == "") {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }
      this.setbulous = true;
      this.secitemUseid = secitem.tid;
      let tids = secitem.tid;
      let tid = this.tid;
      this.updateAgree(tids, index, nums);
    },

    // 查看用户回复条数
    Reply(item, index) {
      this.pageNum = 1;
      this.statTwo = 0;
      console.log("收起回复=>", item);
      this.useId = item.tid;
      this.replyShow = false;
      // this.bulous = false;
      let tid = item.tid;

      if (item.count == 0) {
        this.$message({
          message: "暂无其他回复喔",
          type: "warning"
        });
        return;
      }
      if (!this.show) {
        this.commitReply(tid, index);
        this.replyTwoShow = false;
      } else {
        this.show = !this.show;
      }
    },
    //一级回复
    replyShowclick(item) {
      if (!this.userId) {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }
      console.log("一级回复=>", item);
      console.log(this.replyShow);
      this.replyShow = !this.replyShow;
      this.replyTwoShow = false;
      // this.bulous = false;
      this.useId = item.tid;
      this.Oneinput = "";
    },
    //二级回复
    itemReply(secitem) {
      if (this.userId == "") {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }
      console.log("二级回复=>", secitem);
      this.replyShow = false;
      this.bulous = false;
      this.replyTwoShow = !this.replyTwoShow;
      this.secitemId = secitem.tid;
      if (!this.replyTwoShow) {
        this.twoInput = "";
      }
    },
    //一级回复
    OneshowInput(item, index) {
      if (this.userId == "") {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }
      if (this.Oneinput == "") {
        this.$message({
          message: "回复评论不能为空哦",
          type: "warning"
        });
        return;
      }
      if (this.Oneinput.length > 200) {
        this.$message({
          message: "超过字数限制啦",
          type: "warning"
        });
        return;
      }
      console.log(this.Oneinput.length);
      let input = this.Oneinput;
      let fid = item.tid;
      let idss = 0;
      this.addWebComment(item, input, fid, index, idss);
      this.Oneinput = "";
    },
    //二级回复
    TwoshowInput(secitem, fid, index) {
      console.log(fid);
      if (this.userId == "") {
        this.$message({
          message: "暂未登录,请先登录",
          type: "warning"
        });
        return;
      }

      if (this.twoInput == "") {
        this.$message({
          message: "回复评论不能为空哦",
          type: "warning"
        });
        return;
      }
      if (this.twoInput.length > 200) {
        this.$message({
          message: "超过字数限制啦",
          type: "warning"
        });
        return;
      }

      let item = secitem;
      let input = this.twoInput;
      let idss = 1;
      this.addWebComment(item, input, fid, index, idss);
      this.twoInput = "";
    },
    //查看更多
    veiwMore(tid, Datas) {
      this.stat = 1;
      if (this.pageNum > Datas.totalPages) {
        this.$message({
          message: "暂无更多评论",
          type: "warning"
        });
        this.shows = false;
        return;
      }
      this.pageNum = this.pageNum + 1;
      this.commitList(tid);
    },
    //二级查看更多
    veiwtwoMore(a, contData) {
      this.statTwo = 1;
      console.log(a, contData, this.pageNum);
      if (this.pageNum == contData.totalPages) {
        this.$message({
          message: "暂无更多评论啦",
          type: "warning"
        });
        this.showsList = false;
        this.pageNum = 1;
        return;
      }
      this.pageNum = this.pageNum + 1;
      let tid = a;
      this.commitReply(a);
    }
  }
};
</script>
<style lang="less">
.questionDetails {
  margin-top: 20px;
}
.details-boxs {
  font-family: PingFangSC-Regular;
  width: 1200px;
  padding: 0 36px;
  margin: 20px auto 0;
  background: #ffffff;
  .details-title {
    width: 100%;
    text-align: center;
    padding: 20px 0;
    font-size: 26px;
    color: #333333;
  }
  .details-info {
    height: 30px;
    width: 100%;
    background: #f6f6f6;
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;

    span {
      font-size: 14px;
      color: #999999;
      padding: 0 30px;
    }
  }
  .details-content {
    padding-bottom: 45px;
    p {
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      line-height: 40px;
    }
  }
  .details-next {
    padding: 20px 0;
    border-top: 1px solid #e4e4e4;
    p {
      font-size: 18px;
      color: #5f5f5f;
      letter-spacing: 0;
      cursor: pointer;
    }
  }
}
.question-box {
  width: 100%;
  padding: 20px;
  background: #fff;
  margin-top: 20px;
  padding: 0 45px;
  .ques-box {
    padding: 30px 10px;
    .ques-box-input {
      width: 93.5%;
      border: 1px solid #149508;
      float: right;
      position: relative;
      input {
        float: left;
        width: 80%;
        height: 45px;
        font-size: 16px;
        padding-left: 20px;
      }
    }
  }
}
.view-more {
  width: 100%;
  padding: 40px;
  color: #149508;
  text-align: center;
  cursor: pointer;
}
.img-fabulous {
  width: 25px;
  height: 25px;
  padding-bottom: 10px;
}
.fabu-num {
  color: #999;
}
.ques-p {
  width: 90%;
  padding-left: 20px;
  .margin-p {
    margin: 15px 0;
    span {
      width: 100%;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
  .margin-pss {
    width: 960px;
    margin: 15px 0;
    span {
      word-wrap: break-word;
    }
  }

  p {
    .color-nine {
      color: #999;
    }
    .ques-name {
      padding-right: 20px;
      color: #149508;
    }
  }
}
.imgDateil {
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -o-flex;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -o-justify-content: center;
  padding-bottom: 30px;
  img {
    width: 30%;
    height: 200px;
    margin: 10px 10px;
  }
}
.ques-box-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.img-top {
  width: 20px;
  height: 20px;
}
.reply-li {
  padding: 20px 10px;
  border-top: 1px solid #e4e4e4;
}
input {
  background: none;
  outline: none;
  border: none;
}
.curSot {
  cursor: pointer;
}
.left {
  float: left;
}
.right {
  float: right;
}
// elem组件修改
// .el-button {
//   width: 100px;
//   background: #149508;
//   height: 45px;
//   font-size: 16px;
//   border: none;
//   float: right;
//   border-radius: 1px;
// }
// 导航
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/questionDetails.vue